module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<gmf-search\n  search-loading\n  gmf-search-input-value="$ctrl.inputValue"\n  gmf-search-map="::$ctrl.map"\n  gmf-search-options="::$ctrl.typeaheadOptions"\n  gmf-search-listeners="::$ctrl.searchListeners"\n  gmf-search-options-name="$ctrl.optionsName"\n>\n</gmf-search>\n';

}
return __p
}